export function validarTamanhoDocumento(numeroStr, docLength) {
  const numero = numeroStr.replace(/[.-\s]/g, '');
  return numero.trim() === '' || numero.length !== docLength;
}
